const state = {
  user_type: "",
  user_id: "",
  closedAppointment: true,
};

// getters
const getters = {};

// mutations
const mutations = {
  setUserType: (state, value) => {
    value ? (state.user_type = value) : (state.user_type = "");
  },
  setUserID: (state, value) => {
    value ? (state.user_id = value) : (state.user_id = "");
  },
  closedAppointment(state, data) {
    state.closedAppointment = data;
  },
};

// actions
const actions = {
  setUserType: (context, payload) => {
    context.commit("setUserType", payload);
  },
  setUserID: (context, payload) => {
    context.commit("setUserID", payload);
  },
  closedAppointment({ commit }, data) {
    commit("closedAppointment", data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js